import React from "react";
import Card from "components/card";
import {
    LuMessageSquare,
    LuEye,
} from "react-icons/lu"
import AccessButton from "components/button/accessbutton";
import { CATEGORY_ICONS } from "variables/constants"

const TicketCard = ({ recordData, variant = 'it-support' }) => {
    const Icon = CATEGORY_ICONS[recordData?.ticket_category] || LuMessageSquare;
    
    const config = {
        'it-support': {
            baseRoute: '/console/it-support',
            gradientFrom: 'from-blue-500',
            gradientTo: 'to-cyan-500',
            hoverBorderClass: 'hover:border-blue-300',
            darkHoverBorderClass: 'dark:hover:border-blue-800',
            darkBorderClass: 'dark:border-slate-700',
            cardExtraClass: 'border-slate-200'
        },
        'hr-support': {
            baseRoute: '/console/hr-support',
            gradientFrom: 'from-pink-500',
            gradientTo: 'to-rose-500',
            hoverBorderClass: 'hover:border-pink-300',
            darkHoverBorderClass: '',
            darkBorderClass: 'dark:border-slate-700',
            cardExtraClass: 'border-slate-200'
        },
        'partner-service': {
            baseRoute: '/console/partner-service',
            gradientFrom: 'from-purple-500',
            gradientTo: 'to-indigo-500',
            hoverBorderClass: 'hover:border-purple-300',
            darkHoverBorderClass: '',
            darkBorderClass: 'dark:border-slate-700',
            cardExtraClass: 'border-slate-200'
        }
    };
    
    const currentConfig = config[variant] || config['it-support'];
    
    const cardClassName = `bg-white text-slate-900 flex flex-col gap-6 rounded-2xl border-2 ${currentConfig.cardExtraClass} ${currentConfig.darkBorderClass} ${currentConfig.hoverBorderClass} ${currentConfig.darkHoverBorderClass} hover:shadow-lg transition-all overflow-hidden dark-mode-card`;

    return (
        <div className="space-y-4">
            <Card className={cardClassName}>
                <div className="pb-6 p-4">
                    <div className="flex items-start gap-4">
                        <div className={`p-3 rounded-2xl bg-gradient-to-br ${currentConfig.gradientFrom} ${currentConfig.gradientTo} text-white shadow-md`}>
                            <Icon className="w-5 h-5" />
                        </div>
                        <div className="flex-1 min-w-0">
                            <div className="flex items-start justify-between mb-2">
                                <div>
                                    <h4 className="font-semibold text-[14px] mb-1 title-text">
                                        {recordData?.tic_title}
                                    </h4>
                                    <p className="text-[11px] muted-text ">
                                        {recordData?.tic_code}  • Submitted by {recordData?.submitted_by}
                                    </p>
                                </div>
                                <div className="flex items-center gap-2">
                                    <span className={`status-indicator ${recordData?.ticket_priority?.toLowerCase()} text-[11px]`}>
                                        {recordData?.ticket_priority}
                                    </span>
                                    <span className={`status-indicator ${recordData?.ticket_status?.toLowerCase().replace(/\s+/g, "-")} text-[11px]`}>
                                        {recordData?.ticket_status}
                                    </span>
                                </div>
                            </div>
                            <p className="text-[12px] muted-text line-clamp-2 mb-3">
                                {recordData?.tic_description}
                            </p>
                            <div className="flex items-center justify-between">
                                <div className="flex items-center gap-4 text-[11px] muted-text">
                                    <span>{recordData?.ticket_category}</span>
                                    <span>•</span>
                                    <span className="flex items-center gap-1">
                                        <LuMessageSquare className="w-3 h-3" />
                                        {recordData?.replies_count} replies
                                    </span>
                                    <span>•</span>
                                    <span>Updated {recordData?.update}</span>
                                </div>
                                <AccessButton
                                    label="View"
                                    baseRoute={currentConfig.baseRoute}
                                    recordId={recordData?.tic_id}
                                    iconStart={<LuEye className="w-3 h-3 -mr-2" />}
                                    btnClass="btn-view"
                                    recordData={recordData}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </Card>
        </div>
    )
};

export default TicketCard;